module.exports = __webpack_public_path__ + "fonts/ConfigCondensed-MediumItalic.8b72b910.otf";